/**
 * Returns true when a field value should be treated as "not filled".
 *
 * - null / undefined  → empty
 * - empty string ''   → empty
 * - 0 and false       → NOT empty (valid filled values)
 *
 * Works uniformly across text inputs, Form.Select dropdowns (empty
 * placeholder option yields value=''), and date inputs.
 */
export const isFieldEmpty = (v: unknown): boolean =>
    v === null || v === undefined || v === '';
